
// * ========================================================================
// * Make tables sortable
// * ========================================================================

const sortFunctions = {
    string: {
        down: function (a, b) {
            return a.localeCompare(b, 'fi');
        },
        up: function (a, b) {
            return b.localeCompare(a, 'fi');
        }
    },
    number: {
        down: function (a, b) {
            return a === b ? 0 : a < b ? 1 : -1;
        },
        up: function (a, b) {
            return a === b ? 0 : a > b ? 1 : -1;
        },
    }
};

class Tablesorter {

    constructor(table) {
        this.table = table;
        this.rowData = [];
        this.sortTypes = [];

        for (let x = 0; x <= this.table.rows[0].children.length - 1; x++) {
            const item = this.table.rows[0].children[x];
            if (item.nodeName === 'TH') {
                this.table.rows[0].classList.add('table-head-row');
                this.sortTypes.push(item.getAttribute('data-sort') || 'string');
            }
        }

        for (let i = 1; i <= this.table.rows.length - 1; i++) {
            const row = {
                values: [],
                markup: this.table.rows[i].innerHTML
            };

            // Get values of each column
            for (let x = 0; x <= this.table.rows[i].children.length - 1; x++) {
                if (this.table.rows[i].children[x].nodeName === 'TH') {
                    break;
                }

                this.table.rows[i].classList.add('table-content-row');

                const dataItem = this.table.rows[i].children[x];
                let value = dataItem.getAttribute('data-value') || dataItem.innerHTML;
                value = this.sortTypes[x] === 'number' ? parseFloat(value) : value.toLowerCase();

                row.values.push(value);
            }

            if (row.values.length) {
                this.rowData.push(row);
            }
        }

        this.table.classList.add('table-sortable');

        const context = this;
        this.headings = this.table.querySelectorAll('th');
        this.headings.forEach((th, idx) => {
            // Create click handler table headings
            th.addEventListener('click', function(event) {
                context.sortBy(th, idx);
            });
        })
    }

    sortTable(columnIdx, sortDir, sortType) {
        if (typeof sortFunctions[sortType][sortDir] !== 'undefined') {
            this.rowData.sort(function(a,b) { return sortFunctions[sortType][sortDir](a.values[columnIdx], b.values[columnIdx])});
        }

        // Replace old
        const rows = this.table.querySelectorAll('.table-content-row');
        rows.forEach((row, idx) => {
            row.innerHTML = this.rowData[idx].markup;
        });
    }

    sortBy(th, idx = null) {
        if (!th) {
            return;
        }

        // Get default sort dir
        const defaultSortDir = th.getAttribute('data-default-sort-dir') || 'down';

        // Change sort direction
        // For now, always down
        /*let sortDir = th.getAttribute('data-sort-dir') || defaultSortDir;
        sortDir = sortDir === 'up' ? 'down' : 'up';
        th.setAttribute('data-sort-dir', sortDir);*/

        this.headings.forEach((heading) => {
            heading.classList.remove('sorting');
        });
        th.classList.add('sorting');

        // Get sort type
        const sortType = th.getAttribute('data-sort') || 'string';

        // Get index for current th
        if (!idx) {
            for (let i = 0; i <= th.parentNode.children.length; i++) {
                if (th.parentNode.children[i] === th) {
                    idx = i;
                    break;
                }
            }
        }

        this.sortTable(idx, defaultSortDir, sortType);
    }
}

module.exports = Tablesorter;
